// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get, flatMap } from 'lodash/fp';

// Styles
import './DrawingEditorStrokePointsDebugger.scss';

const DrawingEditorStrokePointsDebugger = (props) => {
    const { paths } = props;

    const strokes = flatMap(get('stroke'), paths);

    return (
        <div className="DrawingEditorStrokePointsDebugger">
            {strokes.map(([x, y], index) => (
                <div key={index} className="point" style={{ left: x, top: y }} />
            ))}
        </div>
    );
};

DrawingEditorStrokePointsDebugger.propTypes = {
    paths: PropTypes.array,
};

export default DrawingEditorStrokePointsDebugger;
